import { cva } from 'class-variance-authority';
import { getListingPrice, resolveListingDataValue } from '@pkgs/components/utils/listingDataUtils';
import { Copy } from '@ev-tech/ui-core-components/Copy';

import { useDefaultSearchResultCardContext, useUAExclusiveSearchResultCardContext } from './SearchResultCardProvider';

import styles from './SearchResultCardContent.module.css';

const priceContainerVariants = cva(styles.priceContainer, {
  variants: {
    variant: {
      default: styles.defaultPriceContainer,
      preview: styles.previewPriceContainer,
    },
  },
});

const priceVariants = cva(styles.price, {
  variants: {
    variant: {
      default: null,
      preview: styles.previewPrice,
    },
  },
});

export const SearchResultCardPrice = () => {
  const { currency, language, listing, translationResolver: t, variant } = useDefaultSearchResultCardContext();
  const descriptor = getListingPrice(listing, { currency, language });
  const price = resolveListingDataValue(descriptor, t);
  const convertedPrice = descriptor.convertedValue;
  const priceLabel = t(descriptor.labelKey);

  return (
    <div className={priceContainerVariants({ variant })}>
      {Boolean(priceLabel && descriptor.value) && (
        <Copy testId="search-components_result-card_price_label" className={styles.priceLabel} as="p" size="m" text={priceLabel} />
      )}
      <div className={styles.priceValueContainer}>
        <Copy className={priceVariants({ variant })} size="xl" text={price} testId="search-components_result-card_price" />
        {Boolean(convertedPrice) && (
          <Copy testId="search-components_result-card_converted-price" className={styles.convertedPrice} size="m" text={convertedPrice} />
        )}
      </div>
    </div>
  );
};

export const ExclusiveSearchResultCardPrice = () => {
  const { currency, language, listing, translationResolver: t, variant } = useUAExclusiveSearchResultCardContext();
  const descriptor = getListingPrice(listing, { currency, language });
  const price = resolveListingDataValue(descriptor, t);
  const convertedPrice = descriptor.convertedValue;
  const priceLabel = t(descriptor.labelKey);

  return (
    <div className={priceContainerVariants({ variant })}>
      {Boolean(priceLabel) && (
        <Copy testId="search-components_result-card_price_label" className={styles.priceLabel} as="p" size="m" text={priceLabel} />
      )}
      <div className={styles.priceValueContainer}>
        <Copy className={priceVariants({ variant })} size="xl" text={price} testId="search-components_result-card_price" />
        {Boolean(convertedPrice) && (
          <Copy testId="search-components_result-card_converted-price" className={styles.convertedPrice} size="m" text={convertedPrice} />
        )}
      </div>
    </div>
  );
};
